module.exports = {
      id: "logout-usage",
      viewBox: "0 0 75 28",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#logout",
      toString: function () {
        return this.url;
      }
    }